import React from "react";
import "./RaceReady.css";

// Top of the confirmation page when the challenge-ready checklist is on it:
// challenge logo, "Name, welcome to the …", "Registration complete" and the challenge's own intro text in a card.
export default function RaceReadyHero({ logoUrl, firstName, raceName, children }) {
  // Avoid "the The …" when the challenge name already starts with "The".
  const name = raceName || "challenge";
  const welcome = `Welcome to ${/^the\s/i.test(name) ? "" : "the "}${name}.`;
  return (
    <header className="rr-hero">
      {logoUrl && <img className="rr-welcome-logo" src={logoUrl} alt={`${raceName || "Challenge"} logo`} />}
      <h1 className="rr-hero-title">{firstName ? `${firstName}, ${welcome.charAt(0).toLowerCase()}${welcome.slice(1)}` : welcome}</h1>
      <p className="rr-eyebrow rr-hero-eyebrow">Registration complete ✓</p>
      {children && <div className="rr-card rr-hero-intro">{children}</div>}
    </header>
  );
}
